/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
/**
 * Request EU ConsentData (GDPR)
 * Spec IAB: https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20CMP%20API%20v2.md
 */

import { logDebugging } from '../../log/logger';

// Mensajes de log encolados.
const logQueue = [];

// Inicialización del contador de tiempo para los mensajes de depuración.
const initTime = performance.now();

// Bandera que indica si se tenemos disponible un valor de consentimiento
// ya sea porque nos ha respondido el CMP o porque hemos esperado
// demasidao.
let status = false;

// Cadena de consentimiento del usuario
let consentData = '';

// Cola de peticiones de consentimiento realizadas por el player en el
// periodo en el que aún no tenemos un valor válido.
let queue = [];

// Número máximo de intentos de comunicación con el CMP.
const maxAttemps = 10;

// Bandera que indica si ya hemos recibido respuesta a un ping.
let pong = false;

// Temporizador de tiempo máximo de respuesta del CMP ante una solicitud de
// ping.
let pingWatchdog = null;

// Tiempo máximo de respuesta del CMP a una petición de ping.
const pingWatchdogTime = 5e3;

// Temporizador de tiempo máximo de espera de una respuesta del CMP.
let watchdog = null;

// Tiempo máximo de respuesta del CMP a una petición getConsentData.
const watchdogTime = 8e3;

// Intervalo para preguntar al CMP por la cadena de consentimiento.
let interval;

// Contador del número de veces que se ha intentado obtener la cadena de
// consentimiento llamando al CMP.
let attemps;

function addLogToQueue(message) {
  logDebugging(message);
  // eslint-disable-next-line prefer-rest-params
  // let newArguments = arguments;
  // let index;
  // let len;
  // if (typeof newArguments === 'object') {
  //   if (typeof newArguments[0] !== 'string') {
  //     len = newArguments.length;
  //     const tmpArguments = [];
  //     tmpArguments[0] = `[CMP] (${performance.now() - initTime} ms) %o`;
  //     for (index = 0; index < len; index++) {
  //       tmpArguments[index + 1] = newArguments[index];
  //     }
  //     newArguments = tmpArguments;
  //   } else {
  //     newArguments[0] = `[CMP] (${performance.now() - initTime} ms) ${newArguments[0]}`;
  //   }
  // }
  // logQueue.push(newArguments);
}

function showLogQueued() {
  const len = logQueue.length;
  if (len > 0) {
    for (let index = 0; index < len; index++) {
      logDebugging.apply(console, logQueue[index]);
    }
  } else {
    logDebugging('Sin mensajes de depuración');
  }
}

/**
 * Manejador de respuestas a peticiones getConsentData.
 * @param {*} response
 */
function consentDataHandler(response) {
  if (response.cmpStatus === 'loaded') {
    consentData = response.tcString;
    addLogToQueue(
      `Tenemos respuesta del CMP, establecemos el valor del consentData a: ${consentData}`,
    );
    if (watchdog) {
      clearTimeout(watchdog);
      watchdog = null;
    }
    clearInterval(interval);
    status = true;
    // eslint-disable-next-line no-use-before-define
    processQueue();
  }
}

/**
 * Realizar una petición getConsentData al CMP en nuestro ancestro más
 * alto.
 */
function getCmp() {
  addLogToQueue('Realizamos petición de consentData al CMP2.');
  if (typeof __tcfapi === 'function') {
    __tcfapi('getTCData', 2, (tcReturn, success) => {
      if (success) {
        addLogToQueue(`Tenemos respuesta del CMP: ${tcReturn}`);
        consentDataHandler(tcReturn);
      }
    });
  } else {
    logDebugging(
      'window.__tcfapi must be defined before initializing the CMP. Confirm the head tag is set.',
    );
  }
}
/**
 * Manejador de respuestas a peticiones de ping.
 * @param {*} response
 */
function pingHandler(response) {
  if (!pong && response.cmpStatus === 'loaded') {
    clearTimeout(pingWatchdog);
    pingWatchdog = null;
    pong = true;
    attemps = 1;
    interval = setInterval(() => {
      // eslint-disable-next-line no-plusplus
      if (attemps++ > maxAttemps) {
        clearInterval(interval);
      } else {
        addLogToQueue('Petición desde intervalo');
        getCmp();
      }
    }, 4e3);
  }
}

/**
 * Respondemos a todas las solicitudes de consentData del player que se
 * hayan podido encolar.
 */
function processQueue() {
  addLogToQueue(
    `Procesamos las peticiones de consentData que se hayan encolado con: "%s"${consentData}`,
  );
  try {
    for (let i = 0; i < queue.length; i++) {
      addLogToQueue(`Respondiendo a petición encolada con: ${consentData}`);
      queue[i](consentData);
    }
    queue = [];
  } catch (error) {
    addLogToQueue(`[ERROR] Al procesar las peticiones encoladas: ${error}`);
  }
}

function showConsentData() {
  logDebugging('[CMP] (%d) ConsentData: "%s"', performance.now() - initTime, consentData);
}

//-------------------------------------------------------------------------

/**
 * Solicitud del player para conocer el consentData.
 */
function getConsentData() {
  addLogToQueue('Solicitud de consentData version 2');
  return new Promise((resolve) => {
    if (status) {
      addLogToQueue(
        'Solicitud de consentData: Tenemos datos y respondemos inmediatamente con "%s"',
        consentData,
      );
      resolve(consentData);
    } else {
      addLogToQueue(
        'Solicitud de consentData: Aún no tenemos datos debemos esperar a que responda el CMP, encolamos la petición',
      );
      queue.push(resolve);
    }
  });
}

//-------------------------------------------------------------------------

// function getDirectConsentData() {
//   return consentData;
// }

/**
 * Superado el tiempo máximo de respuesta a una petición de ping al CMP.
 * Consideramos que no hay CPM.
 */
function pingTimeout() {
  addLogToQueue('Timeout, en solicitud de ping a CMP, consideramos que no hay CMP');
  if (watchdog) {
    clearTimeout(watchdog);
    watchdog = null;
  }
  pingWatchdog = null;
  status = true;
  processQueue();
}

//-------------------------------------------------------------------------

/**
 * Superado el tiempo máximo de respuesta del CMP ante una petición
 * getConsentData, Para no bloquear las peticiones desde el player de forma
 * indefinida, se responderá a las peticiones encoladas con una cadena
 * vacía. En caso de que la respuesta desde el CMP se produjese
 * posteriormente se actualizará el consentData y estará disponible para
 * futuras peticiones desde el player.
 */
function timeout() {
  addLogToQueue('Timeout, no tenemos respuesta del CMP');
  watchdog = null;
  status = true;
  processQueue();
}

//-------------------------------------------------------------------------

/**
 * Realiza una petición de ping al CMP en nuestro ancestro más alto.
 */
function ping() {
  if (typeof __tcfapi === 'function') {
    __tcfapi('ping', 2, (pingReturn, success) => {
      if (success) {
        addLogToQueue('Tenemos respuesta del CMP: %o', pingReturn);
        pingHandler(pingReturn);
      }
    });
  } else {
    logDebugging(
      'window.__tcfapi must be defined before initializing the CMP. Confirm the head tag is set.',
    );
  }
}

/**
 * Proceso inicial:
 * - Activa el manejador de respuestas del CMP.
 * - Realiza un ping al CMP.
 * - Activa el temporizador de tiempo máximo de espera.
 * - Realiza un solicitud getConsentData al CMP.
 */
function init() {
  addLogToQueue('Inicializar sistema Consent_data_2');
  ping();
  pingWatchdog = setTimeout(pingTimeout, pingWatchdogTime);
  watchdog = setTimeout(timeout, watchdogTime);
  getCmp();
}

// function getVersion() {
//   return 'version 2';
// }

//-------------------------------------------------------------------------

window.showCmpLogs = showLogQueued;

window.showConsentData = showConsentData;

//-------------------------------------------------------------------------

export default {
  init,
  getConsentData,
};
